module.exports = __webpack_public_path__ + "assets/images/sKfTzooG.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wopi-clipped-puzzle.png
// module id = 427
// module chunks = 0